import { useState, DragEvent, PropsWithChildren } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { selecZoom } from 'store/features/zoom/zoomSlice';
import { AppDispatch } from 'store';
import { Wrapper, DragDropElement } from './DragDropFileUpload.style';

const DragDropFileUpload = ({
    addFileInputHandler,
    children,
    emptyView
}: PropsWithChildren<{
    addFileInputHandler: (FileList: FileList | null, dispatch: AppDispatch) => Promise<void>;
    emptyView?: boolean;
}>) => {
    const zoom = useAppSelector(selecZoom);
    const dispatch = useAppDispatch();

    const [dragActive, setDragActive] = useState(false);

    const handleDrag = function (e: DragEvent<HTMLDivElement>) {
        const items = e.dataTransfer?.items;
        if (items && (items[0]?.kind === 'file' || items[0]?.type === 'text/uri-list')) {
            e.preventDefault();
            e.stopPropagation();
            if (e.type === 'dragenter' || e.type === 'dragover') {
                setDragActive(true);
            } else if (e.type === 'dragleave') {
                setDragActive(false);
            }
        }
    };

    const handleDrop = function (e: DragEvent<HTMLDivElement>) {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer?.files?.length) {
            addFileInputHandler(e.dataTransfer.files, dispatch);
        }
    };

    return (
        <Wrapper onDragEnter={handleDrag} isDragActive={dragActive} zoom={zoom} emptyView={emptyView}>
            {children}
            {dragActive ? (
                <DragDropElement
                    onDragEnter={handleDrag}
                    onDragLeave={handleDrag}
                    onDragOver={handleDrag}
                    onDrop={handleDrop}
                />
            ) : null}
        </Wrapper>
    );
};

export default DragDropFileUpload;
